import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import BusinessCategoryFormLayer from "../components/BusinessCategoryFormLayer";

const BusinessCategoryFormPage = () => {
  return (
    <>
      <MasterLayout>
        <BusinessCategoryFormLayer />
      </MasterLayout>
    </>
  );
};

export default BusinessCategoryFormPage;
